export default function useDataTransform(props, data) {
  if (!data) return data

  return data[0]?.has_pending_tasks || false
}
